import { TAGS } from "../constants";
import { Medication, MedicationTitration } from "../types";
import { api } from "./api";

export const medicationTitrationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMedicationForPatient: builder.query<
      Medication,
      { patient_id: number; product_slug: string; state: string | null }
    >({
      query: ({ patient_id, product_slug, state }) => ({
        method: "GET",
        url: `/api/medication-titrations/${state}/product/${product_slug}/patient/${patient_id}`,
      }),
      providesTags: [TAGS.MEDICATION_TITRATIONS],
    }),
    getMedicationTitrations: builder.query<
      MedicationTitration[],
      { medication_id?: number; product_id?: number; titration_id?: number }
    >({
      query: (params) => ({
        method: "GET",
        url: `/api/medication-titrations`,
        params,
      }),
      providesTags: [TAGS.MEDICATION_TITRATIONS],
    }),
  }),
});

export const {
  useGetMedicationForPatientQuery,
  useGetMedicationTitrationsQuery,
} = medicationTitrationsApi;
